/*
 * Kozmoz Hall - Bundle cart notification bridge
 *
 * The SMART Discounts "Bundle Deal" widget adds items via
 * fetch('/cart/add?_bundle_sent=1') but does NOT trigger the theme's
 * <cart-notification>, so the shopper gets no feedback that items were added.
 *
 * This patches window.fetch: after a successful bundle /cart/add it opens the
 * theme's native <cart-notification> (the exact Shopify/Dawn popup), showing
 * the most-recently-added line item, just like a normal add-to-cart.
 *
 * Safe: it only reacts to bundle adds (URL contains _bundle_sent), so native
 * single-item adds are untouched. If anything fails it silently falls back to
 * refreshing the cart bubble.
 */
(function () {
  'use strict';

  if (window.__kzBundleCartNotify) return;
  window.__kzBundleCartNotify = true;

  var origFetch = window.fetch;

  function refreshBubble() {
    return origFetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var html = s['cart-icon-bubble'];
        var el = document.getElementById('cart-icon-bubble');
        if (el && html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var wrap = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
          if (wrap) el.innerHTML = wrap.innerHTML;
        }
      })
      .catch(function () {});
  }

  function openNativeNotification() {
    var notif = document.querySelector('cart-notification');
    if (!notif || typeof notif.renderContents !== 'function' || typeof notif.getSectionsToRender !== 'function') {
      // No usable notification element: just refresh the bubble.
      return refreshBubble();
    }

    // 1) Find the key of the most-recently-added cart line (last item in cart).
    origFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return refreshBubble();
        var lastItem = cart.items[cart.items.length - 1];
        var key = lastItem.key;

        // 2) Tell the notification which line item to display, then pull the
        //    exact sections Dawn needs with that key in the selector.
        notif.cartItemKey = key;
        var ids = notif.getSectionsToRender().map(function (s) { return s.id; });
        return origFetch('/?sections=' + encodeURIComponent(ids.join(',')))
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            // 3) renderContents() reads parsedState.key + parsedState.sections
            //    and calls open() itself.
            try {
              notif.renderContents({ key: key, sections: sections });
            } catch (e) {
              refreshBubble();
            }
          });
      })
      .catch(refreshBubble);
  }

  window.fetch = function (url) {
    var u = typeof url === 'string' ? url : (url && url.url) || '';
    // Only bundle adds (marked _bundle_sent). Native single-item adds are left
    // to the theme, which already shows the notification for those.
    var isBundleAdd = u.indexOf('/cart/add') !== -1 && u.indexOf('_bundle_sent') !== -1;
    var result = origFetch.apply(this, arguments);

    if (isBundleAdd) {
      result.then(function (res) {
        if (res && res.ok) {
          // Let the cart state commit before we read /cart.js and sections.
          setTimeout(openNativeNotification, 300);
        }
      }).catch(function () {});
    }
    return result;
  };
})();
